import { createContext } from "react";

const ActivityIndicatorContext = createContext();

export default ActivityIndicatorContext;
